import { f7 } from "framework7-vue";

// AdaptiveSheet renders f7-popup on large screens and f7-sheet on small screens.
// Imperative callers that previously used `f7.popup.open(".selector")` must route
// through these helpers so the correct modal variant is opened/closed.
// closeAdaptiveModal() without a selector falls back to F7's own defaults
// (close the active popup/sheet), matching `f7.popup.close()` semantics.

export function openAdaptiveModal(selector, animate) {
  if (selector === undefined || selector === null) return;
  if (f7.$(selector).length === 0) return;
  const sheet = f7.sheet.get(selector);
  if (sheet) {
    f7.sheet.open(selector, animate);
  } else {
    f7.popup.open(selector, animate);
  }
}

export function closeAdaptiveModal(selector, animate) {
  if (selector === undefined || selector === null) {
    f7.popup.close(undefined, animate);
    f7.sheet.close(undefined, animate);
    return;
  }
  if (f7.$(selector).length === 0) return;
  const sheet = f7.sheet.get(selector);
  if (sheet) {
    f7.sheet.close(selector, animate);
  } else {
    f7.popup.close(selector, animate);
  }
}

export function isAdaptiveModalOpen(selector) {
  if (f7.$(selector).length === 0) return false;
  const sheet = f7.sheet.get(selector);
  if (sheet) return sheet.opened;
  const popup = f7.popup.get(selector);
  return !!(popup && popup.opened);
}
